"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldHeader = void 0;
const react_1 = __importStar(require("react"));
const react_draggable_1 = __importDefault(require("react-draggable"));
const clsx_1 = __importDefault(require("clsx"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const table_field_styles_1 = require("./table-field-styles");
const table_field_context_1 = require("./table-field-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
exports.TableFieldHeader = react_1.forwardRef(function TableFieldHeader({ onColumnClick }, ref) {
    const classes = table_field_styles_1.useStyles();
    const { filteredColumns, sorts, setColumnWidth, actionColumnWidth, visibleActionsColumn, } = react_1.useContext(table_field_context_1.TableFieldContext);
    const handleColumnClick = event_callback_hook_1.useEventCallback((column) => {
        if (column.sortkey) {
            onColumnClick(column.datakey);
        }
    });
    return (react_1.default.createElement("div", { ref: ref, className: classes.header },
        visibleActionsColumn && (react_1.default.createElement("div", { className: classes.tableRowActions, style: { width: actionColumnWidth } })),
        filteredColumns.map((column, i) => {
            const { name, datakey } = column;
            const sortIndex = sorts.findIndex((sort) => sort.datakey === datakey);
            const sort = sortIndex !== -1 ? sorts[sortIndex] : undefined;
            return (react_1.default.createElement("div", { key: `${datakey}-${i}`, className: clsx_1.default(classes.tableRowHeader, {
                    [classes.sortable]: column.sortkey,
                }), style: { width: column.width }, onClick: () => handleColumnClick(column) },
                react_1.default.createElement(Typography_1.default, { className: classes.tableRowHeaderLabel, variant: "h6" }, name),
                sort && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ArrowDropDown_1.default, { classes: {
                            root: sort.order === 'ASC' ? classes.iconRotate : '',
                        } }),
                    react_1.default.createElement(Typography_1.default, { variant: "h6" }, sortIndex + 1))),
                react_1.default.createElement("div", { className: clsx_1.default(classes.draggable, classes.headerCellDraggable), onClick: (event) => event.stopPropagation() },
                    react_1.default.createElement(react_draggable_1.default, { axis: "x", defaultClassNameDragging: classes.draggable, onStop: (_, { x }) => setColumnWidth(datakey, column.width + x), position: { x: 0, y: 0 } },
                        react_1.default.createElement("div", { className: classes.draggableIcon }, "\u22EE")))));
        })));
});
//# sourceMappingURL=table-field-header.js.map